import React, { useContext } from "react";
import Text from "antd/lib/typography/Text";
import { Col, Row } from "antd";
import { LinkOutlined } from "@ant-design/icons";

import Sidebar from "../../../components/Sidebar";
import Badge from "../../../components/Badge";
import { StoreContext } from "../../../context";
import { DateFormat } from "../../../helpers";

export default function ReviewSidebar({
  visible = false,
  data = {},
  onClose = () => { },
  orderRefHandler = () => { },
}) {
  const { storeId } = useContext(StoreContext);

  return (
    <Sidebar
      title="Review Details"
      visible={visible}
      onClose={onClose}
      footer={null}
    >
      <Row>
        {!storeId && data.store_name && (
          <Col className="lblc" xs={24}>
            <Text style={{ fontSize: 11 }} type="secondary">
              Store Name
            </Text>
            <br />
            <Text>{data.store_name}</Text>
          </Col>
        )}
        <Col className="lblc" xs={24} md={12}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Order Id
          </Text>
          <br />
          <Text>
            <a href="#" onClick={orderRefHandler} title="View Order">
              {data.order_id} <LinkOutlined />
            </a>
          </Text>
        </Col>
        <Col className="lblc" xs={24} md={12}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Date
          </Text>
          <br />
          <Text>{DateFormat(data.created_at)}</Text>
        </Col>
        <Col className="lblc" xs={24}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Customer Name
          </Text>
          <br />
          <Text>{data.name}</Text>
        </Col>
        <Col className="lblc" xs={24}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Product Name
          </Text>
          <br />
          <Text>{data.product_name}</Text>
        </Col>
        <Col className="lblc" xs={24}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Rating
          </Text>
          <br />
          <Badge rating={data.rating}></Badge>
        </Col>
        <Col className="lblc" xs={24}>
          <Text style={{ fontSize: 11 }} type="secondary">
            Details
          </Text>
          <br />
          <Text>{data.description}</Text>
        </Col>
      </Row>
    </Sidebar>
  );
}
